import React from "react";

const MESSAGE =
  "Beware of fraud! Always use our secure Repayment on Website Link for loan payments. Do not make direct bank payments to fake UPI links or unauthorised payment links. Udhaar Portal is not responsible for payments made to other accounts.";

export default function FraudWarningMarquee() {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        backgroundColor: "#DC2626",
        color: "#ffffff",
        boxShadow: "0 -2px 8px rgba(0,0,0,0.15)",
      }}
      role="status"
      aria-live="polite"
    >
      <marquee
        behavior="scroll"
        direction="left"
        scrollamount="5"
        style={{
          display: "block",
          padding: "8px 0",
          fontSize: "13px",
          fontWeight: 500,
          letterSpacing: "0.025em",
        }}
      >
        {MESSAGE}
        &nbsp;&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;&nbsp;
        {MESSAGE}
      </marquee>
    </div>
  );
}
